import { useMutation, useQueryClient } from "@tanstack/react-query";
import useSelectedStores from "@lib/hooks/use-selected-stores";
import type { Dashboard } from "@lib/types/dashboards";
import {
  createDashboardWithUpdatedMetadata,
  invalidateDashboardQueries,
  type UpdateDashboardMetadataInput,
  updateDashboardOnServer,
} from "./utils";

export function useUpdateDashboard() {
  const queryClient = useQueryClient();
  const { selectedOrganisation } = useSelectedStores();

  return useMutation({
    mutationFn: async ({
      dashboard,
      updates,
    }: {
      dashboard: Dashboard;
      updates: UpdateDashboardMetadataInput;
    }) => {
      if (!selectedOrganisation) {
        throw new Error("Organisation ID is required");
      }

      return updateDashboardOnServer(
        selectedOrganisation,
        dashboard.id,
        createDashboardWithUpdatedMetadata(dashboard, updates)
      );
    },
    onSuccess: async (updatedDashboard) => {
      await invalidateDashboardQueries(
        queryClient,
        selectedOrganisation,
        updatedDashboard.id
      );
    },
  });
}
